import { createWebPersistentAtom } from "@/stores/persistent"

export const $arvQuestionsAsked = createWebPersistentAtom<string[]>(
  "arvQuestionsAsked",
  []
)

export const haveAskedARVQuestion = (analysisId: string) => {
  return !!$arvQuestionsAsked.get().find((id) => analysisId === id)
}

export const markARVQuestionedShowed = (analysisId: string) => {
  $arvQuestionsAsked.set([...$arvQuestionsAsked.get(), analysisId])
  $arvQuestionsCounter.set(4)
}

export const showARVQuestion = (analysisId: string) => {
  console.debug(
    `showARVQuestion ${haveAskedARVQuestion(analysisId)} ${$arvQuestionsCounter.get()}`
  )

  // Only show once on any analysis
  if (haveAskedARVQuestion(analysisId)) {
    return false
  }

  const count = $arvQuestionsCounter.get()
  if (count <= 0) {
    return true
  }

  $arvQuestionsCounter.set(count - 1)
  return false
}

export const $arvQuestionsCounter = createWebPersistentAtom<number>(
  "arvQuestionsCounter",
  4
)
